import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';
import { isAgent } from 'src/lib/flow/pageHelpers';

function isEnabled({ answers, inputContext: { channel } }) {
  return !isAgent(answers, channel);
}

const exclusivesDelayPage: FlowPage = {
  slug: () => 'exclusives-final',
  autoAdvance: () => true,
  isEnabled,
  hideProgress: () => true,
  questions: (): FlowQuestion[] => [],
};

export default exclusivesDelayPage;
